import { Injectable } from "@nestjs/common";
import { RmIndentQtyLimitDTO } from "./rm-indent-qty-limit.dto";
import { RmIndentQtyLimit } from "../rm-indent-qty-limit.entity";

@Injectable()
export class RmIndentQtyLimitAdapter{
    public convertDtoToEntity(RmIndentQtyLimitDTO:RmIndentQtyLimitDTO, isUpdate: boolean = false) : RmIndentQtyLimit {
        const rmIndentQtyLimit = new RmIndentQtyLimit();
        rmIndentQtyLimit.rmIndentQtyLimitId=RmIndentQtyLimitDTO.rmIndentQtyLimitId;
        rmIndentQtyLimit.date=RmIndentQtyLimitDTO.date;
        rmIndentQtyLimit.plannedQty=RmIndentQtyLimitDTO.plannedQty;
        rmIndentQtyLimit.indentQty=RmIndentQtyLimitDTO.indentQty;
        rmIndentQtyLimit.isActive=RmIndentQtyLimitDTO.isActive==undefined?true:RmIndentQtyLimitDTO.isActive;
        if (isUpdate) {
            rmIndentQtyLimit.updatedUser = RmIndentQtyLimitDTO.updatedUser;
        } else {
            rmIndentQtyLimit.isActive = true;
            rmIndentQtyLimit.createdUser =RmIndentQtyLimitDTO.createdUser;
        }
       return rmIndentQtyLimit;
      }
      public convertEntityToDto(rmIndentQtyLimitObject: RmIndentQtyLimit): RmIndentQtyLimitDTO {
        const rmIndentQtyLimitDTO= new RmIndentQtyLimitDTO;
        rmIndentQtyLimitDTO.rmIndentQtyLimitId=rmIndentQtyLimitObject.rmIndentQtyLimitId;
        rmIndentQtyLimitDTO.date=rmIndentQtyLimitObject.date;
        rmIndentQtyLimitDTO.plannedQty=rmIndentQtyLimitObject.plannedQty;
        rmIndentQtyLimitDTO.indentQty=rmIndentQtyLimitObject.indentQty;
  
        rmIndentQtyLimitDTO.isActive=rmIndentQtyLimitObject.isActive;
        rmIndentQtyLimitDTO.createdAt=rmIndentQtyLimitObject.createdAt;
        rmIndentQtyLimitDTO.updatedAt=rmIndentQtyLimitObject.updatedAt;
        rmIndentQtyLimitDTO.createdUser=rmIndentQtyLimitObject.createdUser;
        rmIndentQtyLimitDTO.updatedUser=rmIndentQtyLimitObject.updatedUser;
        rmIndentQtyLimitDTO.versionFlag=rmIndentQtyLimitObject.versionFlag;
        return rmIndentQtyLimitDTO;
    }
}

